module.exports = __webpack_public_path__ + "static/media/svg-country.7fced72f.svg";